import React from 'react'

import Navbar from '../Components/Navbar/Navbar'
import AgentCom from '../Components/AgentCompo/AgentCom'
import Footer from '../Components/Footer/Footer'

const Agent = () => {
  return (
    <div>
        <Navbar />
        <AgentCom />
        <Footer />
    </div>
  )
}

export default Agent